import proxiedFetch  from '@/lib/proxied-fetch';
import { API } from '@/constants/api';
import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { Card, CardContent } from '@/components/ui/card';
import { useCategoryStore } from '@/store/category-store';
import { useMarketplace } from '@/hooks/useMarketplace';
import { CategoriesShimmer } from '@/components/ui/shimmer';
import { storageService } from '@/services/storage.service';
import { useAuth } from "@/hooks/use-auth";
import { useMarketplaceStore } from '@/store/marketplace-store';

// Define the category interface
interface Category {
  id: string;
  name: string;
  count: number;
  icon?: string;
}

interface StorageResponse {
  data: any;
  timestamp: number;
}

// Sample category data (fallback if not provided by API)
const defaultCategories: Category[] = [
  {
    id: 'indian',
    name: 'Indian',
    count: 120,
  },
  {
    id: 'chinese',
    name: 'Chinese',
    count: 85,
  },
  {
    id: 'italian',
    name: 'Italian',
    count: 65,
  },
  {
    id: 'thai',
    name: 'Thai',
    count: 45,
  },
  {
    id: 'continental',
    name: 'Continental',
    count: 75,
  },
  {
    id: 'desserts',
    name: 'Desserts',
    count: 60,
  },
];

const Categories = () => {
  const router = useRouter();
  const [categories, setCategories] = React.useState<Category[]>(defaultCategories);
  const [isLoading, setIsLoading] = React.useState(true);
  // const { config } = useMarketplace(); // Assuming useMarketplace hook returns the config object

  const { config, location } = useMarketplaceStore();
  const { session } = useAuth();
  const marketplaceStore = useMarketplaceStore()

  // const marketplaceStore = useMarketplaceStore();
  // const location = marketplaceStore.location;

  // const lat = location.lat;
  // const lng = location.lng;

  console.log(`colors`, config)

  console.log("lat", config?.latitude, "longs : ", config?.longitude);

  React.useEffect(() => {

    const fetchCategories = async () => {
      try {
        const result = await storageService.getItem<StorageResponse>(`marketplace-vendor-login-data-${API.MARKETPLACE_REFERENCE_ID}`);
        console.log('Storage result:', result);
        const access_token = session?.accessToken || '';
        console.log('Fetching categories...');
        const queryParams = new URLSearchParams({
          domain_name: marketplaceStore.getConfigItem("settings.domain_name", ""),
          post_to_get: '1',
          marketplace_user_id: config?.marketplace_user_id ? String(config?.marketplace_user_id) : '', // Convert to string or fallback to empty string
          version: '2',
          latitude: location?.lat ? String(location?.lat) : String(config?.latitude || ''), // Convert to string or fallback to empty string
          longitude: location?.lng ? String(location.lng) : String(config?.longitude || ''), // Convert to string or fallback to empty string
          dual_user_key: '0',
          language: 'en',
          ...(session?.user?.id && { vendor_id: String(session.user.id) }), // Add vendor_id only if it exists
        });
        
    
        const response = await proxiedFetch(`/api/proxy${API.ENDPOINTS.PARENT_BUSINESS_CATEGORIES}?${queryParams}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'base_version': '1.0.0',
            'device_type': 'WEB',
            'Referer': 'https://webapp.qmin.co.in/',
            'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36'
          },
          cache: 'no-store'
        });
    
        console.log('Response status:', response.status);
        console.log('Response headers:', response.headers);
    
        if (!response.ok) {
          console.error('Error fetching categories:', response.statusText);
          setCategories(defaultCategories);
          return;
        }
    
        const responseData = await response.text();
        console.log('Response data:', responseData);
    
        try {
          const jsonData = JSON.parse(responseData);
          setCategories(jsonData.data.result);
          console.log('Parsed response data:', jsonData.data.result);
        } catch (error) {
          console.error('Error parsing response data:', error);
          setCategories(defaultCategories);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategories(defaultCategories);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, [location?.lat, location?.lng]);

  // Show shimmer during loading
  if (isLoading) {
    return <CategoriesShimmer />;
  }
  
  // Get secondary color from config or use default
  const secondaryColor = config?.colors?.secondary || '#900f21';
  
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Explore Cuisine Categories</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover delicious cuisines from top Qmin restaurants. From traditional Indian flavors to international delights.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
  {categories?.map((category) => (
    <div key={category.id}>
      <Card 
        className="overflow-hidden hover:shadow-lg transition-all duration-300 h-full cursor-pointer"
        onClick={() => {
          if(category.name.toLowerCase() === 'restaurants')  {
            router.push(`/${category.name.toLowerCase()}`);
          }
          else {
          const categoryStore = useCategoryStore.getState();
          categoryStore.setSelectedCategory(Number(category.id), category.name);
          router.push(`/categories/${category.name.toLowerCase()}`);
          }
        }}
      >
        <div className="relative h-32 w-full bg-gray-100">
        <img src={category.icon} alt={category.name} className="h-full w-full object-fit object-cover" />
        </div>
          <CardContent >
            <h3 className="font-semibold text-center">{category.name}</h3>
            <p className="text-xs text-gray-500 text-center">{category.count} Restaurants</p>
          </CardContent>
        </Card>
    </div>
  ))}
</div>

        <div className="text-center mt-10">
          <Link href="/business-category">
            <button 
              className="text-white hover:opacity-90 transition-colors rounded-full px-8 py-2.5"
              style={{ backgroundColor:" #900f21" }}
            >
              View All Categories
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Categories;
